import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';
import { Directive, Input } from '@angular/core';

@Directive({
  selector: `input[type='number'][min][formControlName],[min][formControl],[min][ngModel]`,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MinNumberValidatorDirective,
      multi: true
    }
  ]
})
export class MinNumberValidatorDirective implements Validator {
  private _validator: ValidatorFn;
  @Input() public set min(value: string) {
    this._validator = Validators.min(+value);
  }

  validate(control: AbstractControl): { [ key: string ]: any } {
    return this._validator(control);
  }
}

